// <head> metadata for JobsPage (https://www.dbos.dev/jobs).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Careers at DBOS | Explore Available Positions',
    },
    {
      property: 'og:title',
      content: 'Careers at DBOS | Explore Available Positions',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Careers at DBOS | Explore Available Positions',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/jobs',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
